/**
 * Whether a promo discount (from /api/paddle/check_code) applies to a price.
 *
 * Paddle never converts flat discounts: a flat USD code is silently ignored at a
 * EUR checkout. So flat discounts only apply when the visitor's (localized)
 * currency matches the discount's currency.
 * @param {DiscountData} discount
 * @param {Price} price_data
 * @param {string} [price_fx] currency the price is shown in, if newer than price_data's
 * @returns {boolean}
 */
export const discount_applies = (
    discount,
    price_data,
    price_fx = price_data?.price_fx
) => {
    if (!discount?.active) return false;

    if (
        discount.restrict_to?.length &&
        !discount.restrict_to.includes(price_data?.price_id) &&
        !discount.restrict_to.includes(price_data?.product_id)
    )
        return false;

    if (discount.type === 'percentage') return true;

    return (price_fx || 'USD') === discount.currency_code;
};

/**
 * Price after a promo discount. Paddle floors the total at zero when a flat
 * amount exceeds the price.
 * @param {number} price
 * @param {DiscountData} discount
 * @returns {number}
 */
export const apply_discount = (price, discount) =>
    Math.max(
        0,
        discount.type === 'percentage'
            ? price - (price * (discount.amount || 0)) / 100
            : price - (discount.amount || 0)
    );
